import type { ReactElement } from 'react';

export interface TabsNavigationItemProps {
  text: string;
  content: Array<ReactElement>;
  maxColumns: number;
}
export interface TabsV2NavigationProps {
  defaultSelectedTab?: number;
  items: TabsNavigationItemProps[];
  onSelectTab?: (index: number) => void;
}

export enum TabDirection {
  Left = 'Left',
  Right = 'Right',
}
